import React from "react";
import { classNames } from "../../helpers";
import ContactCard, { ContactCardProps } from "./ContactCard";
import { useTwilioChat } from "../../hooks/useTwilioChat";

type ContactListProps = {
  contactList: ContactCardProps[];
  className?: string;
  updateConversationList?: (id: string | number) => void;
  refetchContactList?: () => void;
  refetchConversations?: () => void;
};
export default function ContactList({
  contactList,
  className,
  refetchContactList,
  refetchConversations,
}: ContactListProps) {
  const { addConversationParticipant } = useTwilioChat();
  const addNewParticipant = (
    participantId: number | string,
    participantType: "student" | "candidate" | "liaison" | "tutor"
  ) => {
    addConversationParticipant(
      participantId,
      participantType,
      onContactInitiated
    );
  };

  const onContactInitiated = (twilioId: string) => {
    if (!!refetchContactList) refetchContactList();
    if (!!refetchConversations) refetchConversations();
  };

  return (
    <div className={classNames(className)}>
      {React.Children.toArray(
        contactList.map((props) => (
          <ContactCard
            addConversationParticipant={addNewParticipant}
            key={props?.id}
            {...props}
          />
        ))
      )}
    </div>
  );
}
